import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CategoryService } from 'src/app/services/category.service';
import { NewsService } from 'src/app/services/news.service';
import { map } from 'rxjs/operators';
import { News } from 'src/app/models/news';
import { Subscription } from 'rxjs';

export interface DataSugerencias {
  id: string;
  categoria: string;
  year: string;
  title: string;
  image: string;
  autor: string;
}

let ELEMENT_DATA_NEW: DataSugerencias[] = [];

@Component({
  selector: 'app-noticia',
  templateUrl: './noticia.component.html',
  styleUrls: ['./noticia.component.scss']
})

export class NoticiaComponent implements OnInit, OnDestroy {

  displayedColumns = ['id']
  datasourcenew = ELEMENT_DATA_NEW;
  datasugerecias: DataSugerencias;
  product_id: string;
  noticiaElegida: News;
  news: News[] = [];
  suscrption: Subscription = new Subscription;
  base: string = "";
  base2: string = "";
  id: string = "";
  datosArriba=[];
  datosAbajo=[];

  constructor(private actRoute: ActivatedRoute,
    private newsServ: NewsService,
    private categoryServ: CategoryService) {
    this.product_id = this.actRoute.snapshot.params.id;
    this.newsServ.getVisible().then(news => {
      this.news = news;
        this.cambiar(this.product_id);
        this.llenarDataSourceNew();
    })
  }
  ngOnDestroy(): void {
    this.suscrption.unsubscribe();
  }

  ngOnInit(): void {
  }

  toFb(id: string) {
    this.base = "https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fgrupocentro-ab1e7.web.app%2Fnoticia%2F" + id + "%2F&amp;src=sdkpreparse";
    this.base2 = "https://grupocentro-ab1e7.web.app/noticia/" + id;
  }

  cambiar(id) {
    this.news.forEach(element => {
      if (element.id == id) {
        this.noticiaElegida = element;
      }
    });
    let element = document.getElementById('tpid');
    element.scrollIntoView({ behavior: 'smooth' });
  }

  fragmentarDataSource()
  {
    var i;
    this.datosAbajo=[];
    this.datosArriba=[];
    for(i=0;i<this.datasourcenew.length;i++)
    {
      if(i%2==0)
      {
        this.datosArriba.push(this.datasourcenew[i]);
      }
      else
      {
        this.datosAbajo.push(this.datasourcenew[i]);
      }
    }
  }

  llenarDataSourceNew() {
    ELEMENT_DATA_NEW = [];
    this.news.forEach(element => {
      if (element.category.name == this.noticiaElegida.category.name) {

        this.datasugerecias = {
          id: element.id,
          categoria: element.category.name,
          year: element.dateOfNew,
          image: element.image,
          title: element.title,
          autor: element.autor,
        }
        ELEMENT_DATA_NEW.push(this.datasugerecias);
      }
    });
    this.datasourcenew = ELEMENT_DATA_NEW;
    this.fragmentarDataSource();
  }

  ngAfterContentInit() {
    window.scroll(0, 0);
  }

  ScrollTo() {
    let element = document.getElementById('tpid');
    element.scrollIntoView({ behavior: 'smooth' });
  }
}
